import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { PauseCircleOutlined } from '@ant-design/icons'
import { buildAssignmentPath } from '../../../../../../../utils/link.helper'
import { AssignmentSections } from '../../../../../../../constants/assignment-sections'
import { useVersionId } from '../../../../../../../utils/parseURL.helper'
import { Button } from 'antd'

const ContinueLaterButton = () => {
    const navigate = useNavigate()
    const { token, layerId } = useParams()
    const versionId = useVersionId()

    const handleClick = () => {
        navigate(buildAssignmentPath(token, layerId, AssignmentSections.HOME, versionId))
    }

    return (
        <Button 
            onClick={handleClick}
            icon={<PauseCircleOutlined />}
            type="text"
        >
             Continue Later
        </Button>
    )
}

export default ContinueLaterButton 